import { render } from "./GoogleReviews.vue?vue&type=template&id=75df6434&scoped=true&ts=true"
import script from "./GoogleReviews.vue?vue&type=script&lang=ts"
export * from "./GoogleReviews.vue?vue&type=script&lang=ts"

import "./GoogleReviews.vue?vue&type=style&index=0&id=75df6434&lang=sass&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-75df6434"]])

export default __exports__